import React from 'react';
import { IconButton} from '@mui/material';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import { useLang } from '~/hooks/useLang';
import { LatLng } from 'leaflet';
import { useMarkerState } from '~/features/Map/stores/MapState';

interface DispatchLocationRequesterProps {
  readonly title: string
  readonly latitude: number | null;
  readonly longitude: number | null;
}

export default function DispatchLocationRequester({title, latitude, longitude }: DispatchLocationRequesterProps) {
  const { forceViewMap } = useMarkerState();
  const { translate } = useLang();

  return (
    <IconButton
      disabled={!Boolean(latitude && longitude)}
      title={translate(title)}
      sx={{ margin: '0 !important' }}
      onClick={() => forceViewMap().position.set(new LatLng(Number(latitude ? latitude : 0), Number(longitude ? longitude : '')))}
    >
      <PersonPinIcon />
    </IconButton>
  )
}